import { useState } from 'react';
import { Box, TextField, Button, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

// eslint-disable-next-line react/prop-types
export const LoginForm = ({ onSubmit, isLoading }) => {
  const loginObj = { email: '', password: '' };
  const [login, setLogin] = useState(loginObj);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin({ ...login, [name]: value });
  };

  const handleClickShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(login);
  };

  return (
    <Box
      component="form"
      onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
      onSubmit={handleSubmit}
      noValidate
      autoComplete="off"
    >
      <TextField
        name="email"
        placeholder="Email address"
        value={login.email}
        onChange={handleChange}
        required
        fullWidth
        disabled={isLoading}
        sx={{
          marginBottom: '20px',
          '& .MuiInputBase-root': {
            borderRadius: '8px',
            backgroundColor: '#f7f7f7',
            fontSize: '16px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
          },
        }}
      />
      <TextField
        name="password"
        type={showPassword ? 'text' : 'password'}
        placeholder="Password"
        value={login.password}
        onChange={handleChange}
        required
        fullWidth
        disabled={isLoading}
        sx={{
          marginBottom: '20px',
          '& .MuiInputBase-root': {
            borderRadius: '8px',
            backgroundColor: '#f7f7f7',
            fontSize: '16px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword} edge="end" disabled={isLoading}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={isLoading}
        sx={{
          padding: '7px 15px',
          borderRadius: '8px',
          backgroundColor: '#c00000',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#a00000',
          },
        }}
      >
        LOGIN
      </Button>
    </Box>
  );
};
